import { HUBS } from '../../types/relevancyData';
import { DATA_TYPE_FAMILIES } from './DataTypeFamilies';
export const OnboardingUseCaseRelevancyData = {
  'organize-and-track-contacts': {
    dataTypes: ['0-1', '0-2'] // CONTACT, COMPANY
  },
  'automate-marketing': {
    hubs: [HUBS.MARKETING],
    dataTypes: [DATA_TYPE_FAMILIES.MARKETING_EMAIL]
  },
  'grow-and-manage-sales-pipeline': {
    hubs: [HUBS.SALES],
    dataTypes: ['0-3'] // DEAL
  },
  'generate-leads': {
    hubs: [HUBS.MARKETING],
    dataTypes: [DATA_TYPE_FAMILIES.FORMS, DATA_TYPE_FAMILIES.SOCIAL, DATA_TYPE_FAMILIES.ADS]
  },
  'scale-customer-support': {
    hubs: [HUBS.SERVICE],
    dataTypes: ['0-5', '0-11'] // TICKET, CONVERSATION
  },
  'billing-and-collecting-payments': {
    hubs: [HUBS.COMMERCE],
    dataTypes: ['0-101',
    // COMMERCE_PAYMENT
    '0-69' // SUBSCRIPTION
    ]
  },
  'build-websites-and-landing-pages': {
    hubs: [HUBS.CMS, HUBS.MARKETING],
    dataTypes: [DATA_TYPE_FAMILIES.PAGES]
  },
  'create-marketing-content': {
    hubs: [HUBS.MARKETING, HUBS.CMS],
    dataTypes: [DATA_TYPE_FAMILIES.FORMS, DATA_TYPE_FAMILIES.BLOG, DATA_TYPE_FAMILIES.MARKETING_EMAIL]
  }
};